import React from "react";

interface GlobalModals {
    children: React.ReactNode;
}

export const GlobalModals = ({ children }: GlobalModals) => <div style={{ display: "none" }}>{children}</div>;
